import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartdata(newdata) {
      console.log("watching");
      console.log(newdata);
      this.renderChart(newdata, this.options);
      console.log("changed");
    },
  },
  computed: {
    data() {
      return this.chartdata;
    },
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
};
